<mat-toolbar>Add Contractors Involved</mat-toolbar>
<div class="Dialog-body">
  <form>
    
    <mat-form-field style="width: 400px;padding-top: 1.25em;">
      <input type="text" matInput placeholder="CompanyName" [(ngModel)]="CompanyName" [ngModelOptions]="{standalone: true}">
    </mat-form-field>

    <mat-form-field style="width: 400px;padding-top: 1.25em;">
      <input type="text" matInput placeholder="StaffName" [(ngModel)]="StaffName" [ngModelOptions]="{standalone: true}">
    </mat-form-field>

   

      <div class="buttonbelow">
        <button mat-button (click) = "saveContractors()">Submit</button>
        <button mat-button  (click)="DialogClose()" >Cancel</button>    
      </div>
  </form>

</div>
